import { decodeRuleSourceItemValue, decodeRuleTargetItemValue } from '../utils';
import { AlgorithmTargetValidFormDataSchema } from './AlgorithmTargetValidFormDataSchema';
import { AlgorithmTargetRuleValidFormDataType } from './types';

export const AlgorithmTargetMutationDtoSchema =
  AlgorithmTargetValidFormDataSchema.transform(({ id, rules, ...rest }) => {
    return {
      ...rest,
      id: id !== -1 ? id : null,
      rules: rules.map(
        ({
          id,
          dimensionIndicators,
          sourceItem,
          ...rule
        }: AlgorithmTargetRuleValidFormDataType) => {
          const decodedSource = decodeRuleSourceItemValue(sourceItem);

          const normalizedSource =
            'algorithmSourceId' in decodedSource
              ? {
                  algorithmSourceId: decodedSource.algorithmSourceId,
                  algorithmMappingId: null,
                  sourceItemCode: decodedSource.sourceItemCode,
                }
              : 'algorithmMappingId' in decodedSource
                ? {
                    algorithmSourceId: null,
                    algorithmMappingId: decodedSource.algorithmMappingId,
                    sourceItemCode: null,
                  }
                : {
                    algorithmSourceId: null,
                    algorithmMappingId: null,
                    sourceItemCode: null,
                  };

          return {
            ...rule,
            id: id !== -1 ? id : null,
            ...normalizedSource,
            items: decodeRuleTargetItemValue(dimensionIndicators),
          };
        },
      ),
    };
  });
